import AccentCard from './accent_card';
export default AccentCard;
